// src/redux/masters/noticeSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchMasterNoticeUrl, createUpdateMasterNoticeUrl } from '../../services/masters/noticeService';
import { ACTIONS } from '../../constants/apiEndpoints';

export const fetchNoticeMaster = createAsyncThunk(
  ACTIONS.fetch_master_notice,
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchMasterNoticeUrl();
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const noticeSlice = createSlice({
  name: 'noticesMaster',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNoticeMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNoticeMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchNoticeMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const createUpdateNoticeMaster = createAsyncThunk(
  ACTIONS.creeate_update_master_notice,
  async (noticeObj, { rejectWithValue }) => {
    try {
      const payload = {
        data: JSON.stringify(noticeObj), // stringified inner data
        target: 'society.models.master.notice.NoticeCharges',
        compressed: false
      };
      const response = await createUpdateMasterNoticeUrl(payload);
      
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export default noticeSlice.reducer;
